export default "__VITE_ASSET__CpgZlwRX__"